<template>
  <div class="container max-w-screen-md my-l">
    <div class="text-center font-semibold mb-12 fluid-3xl" v-html="heading"></div>
    <div class="mb-12 lg:w-2/3 m-auto">
      <div v-if="contactOptions.length" class="relative">
        <Listbox v-model="contactId" v-slot="{ open }">
          <div class="relative">
            <ListboxButton class="relative w-full cursor-default rounded-full py-5 px-10 bg-gray-200 text-left">
              <span class="block truncate">{{
                selectedContact ? selectedContact.heading : $t('education.enterLocation')
              }}</span>
              <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-5">
                <DownChevronIcon :down="open" class="h-4 w-4 text-gray-400" aria-hidden="true" />
              </span>
            </ListboxButton>
            <transition
              leave-active-class="transition duration-100 ease-in"
              leave-from-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <ListboxOptions
                class="absolute mt-1 max-h-72 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-xl ring-1 ring-black/5 focus:outline-hidden z-10"
              >
                <ListboxOption
                  v-for="option in contactOptions"
                  :key="option.value"
                  v-slot="{ active, selected }"
                  :value="option.value"
                  as="template"
                >
                  <li
                    :class="[
                      active ? 'bg-gray-100 text-black' : 'text-gray-900',
                      'relative cursor-default select-none py-2 px-4',
                    ]"
                  >
                    <span :class="[selected ? 'font-medium' : 'font-normal', 'block truncate']">
                      {{ option.text }}
                    </span>
                  </li>
                </ListboxOption>
              </ListboxOptions>
            </transition>
          </div>
        </Listbox>
      </div>
    </div>
    <div v-if="selectedContact" class="w-full text-center text-copy" v-html="selectedContact.body"></div>
    <div class="flex flex-wrap text-copy divide-y sm:divide-x sm:divide-y-0 mt-10">
      <div class="w-full sm:w-1/2 py-10 text-center">
        <strong class="block">{{ $t('phone') }}</strong>
        <div v-if="selectedContact">
          <a :href="'tel:' + selectedContact.telephone">{{ selectedContact.telephone }}</a>
          <em class="block not-italic">{{ selectedContact.phoneDescription }}</em>
        </div>
      </div>
      <div class="w-full sm:w-1/2 py-10 text-center">
        <strong>{{ $t('email') }}</strong>
        <div v-if="selectedContact">
          <a :href="'mailto:' + selectedContact.email">{{ selectedContact.email }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue';
import DownChevronIcon from '@/components/icons/DownChevronIcon.vue';

export default defineNuxtComponent({
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    DownChevronIcon,
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    sections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      contactId: null,
    };
  },
  computed: {
    contactOptions() {
      const filterEmpty = this.sections.filter((section) => !!section.heading);
      return filterEmpty.map((section) => ({ value: section.id, text: section.heading }));
    },
    selectedContact() {
      return this.sections?.find((section) => section.id === this.contactId) || null;
    },
  },
  mounted() {
    this.contactId = this.sections.length && this.sections[0].id;
  },
});
</script>

<style>
/* No custom styling needed - using TailwindCSS classes directly */
</style>
